import styled from 'styled-components'

const ProductOptionValuesContainerUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export default ProductOptionValuesContainerUi
